module.exports = __webpack_public_path__ + "img/new_p_1.d6c89f6d.png";